/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddress = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M10 6h8v2h-8zm0 6h8v2h-8zM6 6h2v2H6zm4 3h8v2h-8zm-4 3h2v2H6zm0-3h2v2H6z" />
      <path d="M2 2v20h20V2zm18 18H4V4h16z" />
      <path d="M6 16h12v2H6z" />
    </g>
  </Icon>
);
export { SvgAddress as Address };
